import {
  StyleSheet as AphroditeStyleSheet,
  CSSProperties as AphroditeCSSProperties,
  CSSWideKeyword as AphroditeCSSWideKeyword,
  StyleDeclarationMap as AphroditeStyleDeclarationMap,
} from 'aphrodite/no-important';
import {customSelectors} from './customSelectors';

const customStyleSheet = AphroditeStyleSheet.extend(customSelectors);

export const StyleSheet = customStyleSheet.StyleSheet;
export const css = customStyleSheet.css;

export type CSSProperties = AphroditeCSSProperties;
export type CSSWideKeyword = AphroditeCSSWideKeyword;
export type StyleDeclarationMap = AphroditeStyleDeclarationMap;
